import { DASH } from '@/app/shared/constants/common';
import { VAULT_TRANCHE, VAULT_TRANCHE_LABEL, VaultChartSeriesKey, VaultTrancheId } from '@/app/shared/constants/vaults';

export const resolveTrancheDisplayLabel = (
  name?: string,
  symbol?: string,
  fallback: string = DASH,
): string => {
  const label = `${name ?? ''} ${symbol ?? ''}`.toLowerCase();
  if (label.includes(VAULT_TRANCHE.SENIOR)) return VAULT_TRANCHE_LABEL[VAULT_TRANCHE.SENIOR];
  if (label.includes(VAULT_TRANCHE.JUNIOR)) return VAULT_TRANCHE_LABEL[VAULT_TRANCHE.JUNIOR];
  return symbol || name || fallback;
};

export const resolveTrancheId = (label?: string): VaultTrancheId | undefined => {
  const normalized = label?.toLowerCase() ?? '';
  if (normalized.includes(VAULT_TRANCHE.SENIOR)) return VAULT_TRANCHE.SENIOR;
  if (normalized.includes(VAULT_TRANCHE.JUNIOR)) return VAULT_TRANCHE.JUNIOR;
  return undefined;
};

export const isTotalPerformanceTranche = (name?: string, symbol?: string): boolean => {
  const label = `${name ?? ''} ${symbol ?? ''}`.toLowerCase();
  return label.includes('total');
};

export const resolveVaultChartSeriesKey = (name: string, symbol: string): VaultChartSeriesKey | null => {
  if (isTotalPerformanceTranche(name, symbol)) return null;
  const label = `${name} ${symbol}`.toLowerCase();
  if (label.includes(VAULT_TRANCHE.SENIOR)) return VAULT_TRANCHE.SENIOR;
  if (label.includes(VAULT_TRANCHE.JUNIOR)) return VAULT_TRANCHE.JUNIOR;
  if (symbol.toLowerCase().startsWith('s')) return VAULT_TRANCHE.SENIOR;
  if (symbol.toLowerCase().startsWith('j')) return VAULT_TRANCHE.JUNIOR;
  return null;
};
